// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_GgA","toggleWrap":"styles_toggleWrap__394QP","content":"styles_content__2TaAK","selectAreaCode":"styles_selectAreaCode__eV59e"};